import {httpWithLoader} from "@/http-common";

const state = () => ({
    dialogs: {
        login: false, // Логин
        help: false, // Помощь и запрос
        referenceInformation: false, // Справочная информация
        user: false, // Создание/редактирование пользователя
        ork: false, // ОРК
        orkRename: false, // Редактирование ОРК
        areas: false, // ОПД
        hardSkills: false, // Список хард скиллов
        // Диалоги помимо булева значения могут представлять из себя объект { visible: false, data: {...} } для передачи данных и/или других параметров
        // upd. эту ерунду с окнами надо заменить на обычные props вероятно, оставить просто флаги true/false
        kinds: { // ВПД
            data: {},
            visible: false
        },
        okveds: false, // ОКВЭД
        okz: false, // ОКЗ
        programs: false, // Программы
        trainingPrograms: false,
        qualifications: false, // Список квалификаций
        skillRename: false, // Переименование скилла
        softSkills: false, // Список софт скиллов
        standards: false, // Список стандартов
        tableSettings: false, // Настройки таблиц
        workActions: false, // Трудовые действия
        newGeneralWorkFunctionsDialog: false, // Создание новой общей трудовой функции
        generalWorkFunction: false, // Общие трудовые функции
        workFunctions: false, // Трудовые функции
        workFunctionsRename: false, // переименование трудовые функции
        workFunctionsItemRename: false, // переименование знаний/умений/трудовых действий
        workKnowledge: false, // Знания
        workSkills: false, // Умения
        spk: false, // СПК
        relatedJobs: false,

        /* фильтры */
        filterOrk: false,


        viewTrainingPrograms: false,
        viewQualificationPrograms: false,
    },
    // Панели со статусами 0 - закрыто, 1 - открыто наполовину, 2 - открыто полностью
    panels: {
        competences: 0, // Компетенции
        interrelations: 0, // Взаимосвязи ПК
        qualification: 0, // Редактирование квалификации
        qualifications: 0, // Список квалификаций в шаге ОПД/ВПД/ПС
        standard: 0 // Создание/редактирование стандарта
    },
    alert: {
        status: 'error',
        timer: 5, // 0 или false, если без таймера
        open: false, // Токен открытия алерта
        text: '' // Текст алерта
    },
    currentParent: false,
    currentShowAdd: false,
});

const getters = {
    IS_PANEL_OPEN: (state) => Object.values(state.panels).find((item) => item > 0),
    GET_CURRENT_PARENT: (state) => state.currentParent,
    GET_SHOW_DIAGRAM_ADD: (state) => state.currentShowAdd,
};

const mutations = {
    TOGGLE_DIALOG: (state, payload) => Object.assign(state.dialogs, payload),
    TOGGLE_PANEL: (state, payload) => Object.assign(state.panels, payload),
    TOGGLE_ALERT: (state, payload) => Object.assign(state.alert, payload),
    SET_ALERT_TIMER: (state, payload) => state.alert.timer = payload,
    SET_CURRENT_PARENT: (state, currentParentId) => state.currentParent = currentParentId,
    SET_SHOW_DIAGRAM_ADD: (state, currentShowAdd) => state.currentShowAdd = currentShowAdd,
};

const actions = {
    async SEND_HELP_EMAIL({commit, state, rootState}, params) {
        await httpWithLoader.post(`/help-email`,  params,{
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
            .then((response) => {
                commit('TOGGLE_ALERT', {status: 'success', open: true, timer: 0, text: `Ваше письмо отправлено!`});
        })
            .catch((reject) => {
                console.log(reject);
                handleError(reject, commit)
            });
    }
};


export const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', {
        status: 'error',
        open: true,
        text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз`
    }, {root: true})
    console.log(`url: ${error.config ? error.config.url : '-'}\nmethod: ${error.config ? error.config.method : '-'}\npayload: ${error.config ? error.config.data : '-'}`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    handleError
}
